<template>
  <div class="usual-passenger" id="usual-passenger">
    <div class="usual-passenger-wrap">
      <div class="usercenter-title">
        <h4>常用乘机人</h4>
      </div>
      <div class="usual-passenger-table">
        <a-table
          :columns="columns"
          :dataSource="data"
          :loading="loading"
          :pagination="false"
        >
          <span slot="passengerCards" slot-scope="text">
            <a-popover title="证件信息" v-if="text && text.length">
              <template slot="content">
                <a-table
                  :columns="certColumns"
                  :dataSource="text"
                  :pagination="false"
                >
                  <span slot="issueCountry" slot-scope="text">
                    {{ find(oriDataList, { value: text })?.label }}
                  </span>
                </a-table>
              </template>
              <span>查看 <a-icon type="caret-down" /></span>
            </a-popover>
          </span>
          <span slot="nationality" slot-scope="text">
            {{ find(oriDataList, { value: text })?.label }}
          </span>
          <span slot="telephoneNo" slot-scope="text">
            <span>{{ text.telephoneNo | codeMask }}</span>
          </span>
          <span slot="action" class="table-action" slot-scope="text, record">
            <a href="javascript:void(0);" @click="editPassenger(record.index)">
              <l8-icon
                class="l8-icon"
                type="icon-bianji"
                style="color: #808080; margin-right: 20px;"
              />
            </a>
            <a-popconfirm
              v-if="data.length"
              title="是否确定删除该常用乘机人?"
              okText="确定"
              cancelText="取消"
              @confirm="() => onDelete(record.id)"
            >
              <a href="javascript:void(0);">
                <l8-icon class="l8-icon" type="icon-shanchu" style="color: #808080" />
              </a>
            </a-popconfirm>
          </span>
        </a-table>
        <div class="add-passenger" style="padding-top:20px;">
          <a-button type="primary" size="large" @click="handleAddPassenger">添加乘机人</a-button>
        </div>
        <a-modal
          :title="modalTitle"
          :visible="visible"
          :footer="null"
          :destroyOnClose="true"
          :width="'60vw'"
          @cancel="handleCancel"
        >
          <add-passenger
            :initData="passengerData"
            :passengerId="passengerId"
            :oriDataList="oriDataList"
            :passengerFieldInfo="passengerFieldInfo"
            :size="'large'"
            @addPassenger="addCallback"
          ></add-passenger>
        </a-modal>
      </div>
    </div>
  </div>
</template>
<script>
import AddPassenger from '@/components/addPassenger/addPassenger.vue'
import '@/components/l8-icon'
import codeMask from '../../assets/js/codeMask'
import './index'
import { find, get } from 'lodash'
import { queryUsualPassenger, deleteUsualPassenger } from '@/apis/passenger'
import { usualPassengerMap } from '@/dicts/order'
import { getCountry } from '@/apis/common'

const columns = [
  {
    key: 'index',
    title: '序号',
    dataIndex: 'index',
    align: 'center'
  },
  {
    key: 'passengerName',
    title: '姓名',
    dataIndex: 'passengerName',
    align: 'center'
  },
  {
    key: 'nationality',
    title: '国籍',
    dataIndex: 'nationality',
    scopedSlots: { customRender: 'nationality' },
    align: 'center'
  },
  {
    key: 'passengerCards',
    title: '证件信息',
    dataIndex: 'passengerCards',
    scopedSlots: { customRender: 'passengerCards' },
    align: 'center'
  },
  {
    key: 'birthday',
    title: '出生日期',
    dataIndex: 'birthday',
    align: 'center'
  },
  {
    key: 'telephoneNo',
    title: '联系电话',
    scopedSlots: { customRender: 'telephoneNo' },
    align: 'center'
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center'
  }
]

const certColumns = [
  {
    key: 'idTypeName',
    title: '证件类型',
    dataIndex: 'idTypeName',
    align: 'center'
  },
  {
    key: 'certNo',
    title: '证件号',
    dataIndex: 'certNo',
    align: 'center'
  },
  {
    key: 'issueCountry',
    title: '证件签发国/地区',
    dataIndex: 'issueCountry',
    scopedSlots: { customRender: 'issueCountry' },
    align: 'center'
  },
  {
    key: 'certExpried',
    title: '证件有效期',
    dataIndex: 'certExpried',
    align: 'center'
  }
]

export default {
  data () {
    return {
      data: [],
      loading: true,
      columns,
      certColumns,
      visible: false,
      modalTitle: '添加乘机人',
      passengerData: {
        passengerLastName: '',
        passengerFirstName: '',
        firstName: '',
        lastName: '',
        nationality: '',
        gender: '',
        passengerType: '',
        mobilePhone: '',
        birthday: null
      },
      total: 0,
      oriDataList: [],
      passengerId: '',
      passengerFieldInfo: []
    }
  },
  mounted () {
    this.getDataList()
    this.getCountryByApi()
    this.getCmsData()
    window.__MICRO_ROOT__?.api?.track?.('my_cycjr')
  },
  methods: {
    find,
    async getCmsData () {
      try {
        const cmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) || {}
        this.passengerFieldInfo = get(cmsData, 'passenger-field-info.list') || []
      } catch (err) {}
    },
    getDataList () {
      try {
        queryUsualPassenger({}).then(result => {
          this.loading = false
          this.data = result.map((item, index) => {
            item.key = index + 1
            item.index = index + 1
            item.passengerCards?.forEach(certItem => {
              certItem.idTypeName = usualPassengerMap[certItem.idType]
              certItem.certNo = codeMask(certItem.certificateNo, {
                offset: 4,
                length: 10
              })
            })

            return item
          })

          this.total = this.data.length
        })
      } catch (error) {
        this.loading = false
        this.$message.error(error.message)
      }
    },
    async getCountryByApi () {
      this.oriDataList = await getCountry()
    },
    onDelete (key) {
      try {
        deleteUsualPassenger(key).then(result => {
          this.$message.success('删除常用乘机人成功！')
          this.getDataList()
        })
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    editPassenger (index) {
      this.modalTitle = '编辑乘机人'
      this.passengerData = Object.assign({}, this.data[index - 1])
      this.passengerId = this.passengerData.id
      this.visible = true
    },
    handleAddPassenger () {
      if (this.total === 20) {
        this.$message.error('最多只能添加20个常用乘机人，如需添加，请删除已有的一个乘机人。')
        return
      }
      this.passengerData = {
        passengerLastName: '',
        passengerFirstName: '',
        firstName: '',
        lastName: '',
        nationality: '',
        gender: '',
        passengerType: 'ADT',
        mobilePhone: '',
        birthday: null
      }
      this.visible = true
    },
    addCallback () {
      this.visible = false
      this.getDataList()
    },
    handleCancel () {
      this.visible = false
    }
  },
  components: {
    AddPassenger
  }
}
</script>

<style lang="less">
@media only screen and (max-width: 768px) {
  #usual-passenger {
    .ant-table {
      width: 100%;
      overflow-x: scroll;
      .ant-table-content {
        min-width: 800px;
      }
    }
  }
}
</style>

<style lang="less" scoped>
#usual-passenger {
  padding: 20px;
  .usual-passenger-wrap {
    width: 100%;
  }
  .usual-passenger-table {
    padding-top: 10px;
  }
}
@media only screen and (max-width: 768px) {
  #usual-passenger {
    padding: 10px;
  }
}
</style>
